import { render, staticRenderFns } from "./account-contact-settings.vue?vue&type=template&id=76801d1e"
import script from "./account-contact-settings.vue?vue&type=script&lang=js"
export * from "./account-contact-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports